import { Action } from '../actions';
import {
  mergeEntities,
  mergeListEntities,
  Path,
  pluckListItemFromRawStoreSlice,
  transformObjects,
} from '../helpers';
import { transformMilestoneRequest } from '../milestone-request/milestone-request.transformers';

export function threadMilestoneRequestsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'threadMilestoneRequests') {
        const { result, refList } = action.payload;
        return mergeListEntities<'threadMilestoneRequests'>(
          state,
          transformObjects(
            result.milestone_requests,
            transformMilestoneRequest,
          ),
          refList,
          'projectId',
        );
      }
      return state;
    }
    case 'WS_MESSAGE': {
      if (action.payload.parent_type === 'notifications') {
        switch (action.payload.type) {
          case 'requestMilestone': {
            const { id, requestId } = action.payload.data;
            const milestoneRequestObj = {
              id: Number(requestId),
            };
            const path: Path<'threadMilestoneRequests'> = [
              'threadMilestoneRequests',
              String(id),
            ];
            const ref = { path };
            return mergeEntities<'threadMilestoneRequests'>(
              state,
              transformObjects([String(id)], _ => {
                const threadMilestoneRequest = pluckListItemFromRawStoreSlice(
                  state,
                  path,
                  milestoneRequestObj.id,
                );
                return {
                  ...threadMilestoneRequest,
                  ...milestoneRequestObj,
                };
              }),
              ref,
            );
          }

          default:
            return state;
        }
      }
      return state;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/thread/threadMilestoneRequest.reducer.ts